import { Controller } from '@hotwired/stimulus'

export default class AuthenticatorCodeController extends Controller {
  static targets = ['input', 'hiddenInput'];
  static values = { length: Number };

  connect() {
    this.clearInputs();
    // gestion du focus: la modale est chargée dans le DOM avant son ouverture
    // et donc avant que bootstrap déplace le focus à l'ouverture.
    // Avec une actualisation du contenu de la modale,
    // voir si le controller se connecte à ce moment-là et gère le focus.
    // Si non, il faudra veiller à ce que le focus soit placé automatiquement
    // dans le premier input à l'affichage des champs.
    this.inputTargets[0].focus();
  }

  clearInputs() {
    this.inputTargets.forEach((input) => (input.value = ''));
    this.hiddenInputTarget.value = '';
  }

  handlePaste(event) {
    const pasteData = (event.clipboardData || window.clipboardData)
      .getData('text')
      .trim();
    const digits = pasteData
      .replace(/\D/g, '')
      .slice(0, this.lengthValue)
      .split('');

    this.clearInputs();

    digits.forEach((digit, index) => {
      if (this.inputTargets[index]) {
        this.inputTargets[index].value = digit;
      }
    });

    const nextIndex =
      digits.length < this.lengthValue ? digits.length : this.lengthValue - 1;
    this.inputTargets[nextIndex].focus();
    this.updateHiddenInput();

    // After action handlePaste, trigger input event on last input to update button state
    this.inputTargets[nextIndex].dispatchEvent(new Event('input', { bubbles: true }));
  }

  handleInput(event) {
    const input = event.target;
    const index = parseInt(event.params.index, 10);

    input.value = input.value.replace(/\D/g, '');

    if (input.value && index < this.lengthValue - 1) {
      this.inputTargets[index + 1].focus();
    }

    this.updateHiddenInput();
  }

  handleKeydown(event) {
    const input = event.target;
    const index = parseInt(event.params.index, 10);

    if (event.key === 'Backspace' && !input.value && index > 0) {
      this.inputTargets[index - 1].focus();
    }
  }

  updateHiddenInput() {
    this.hiddenInputTarget.value = this.inputTargets
      .map((i) => i.value)
      .join('');
  }
}
